// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.about-section {
  padding: 150px 0;
}
@media (max-width: 1023px) {
  .about-section {
    padding: 96px 0;
  }
}
.about-section .section-title {
  text-align: center;
  font-size: 52px;
  font-weight: 700;
  margin-bottom: 30px;
  color: #072146;
}
@media (max-width: 1023px) {
  .about-section .section-title {
    font-size: 40px !important;
    margin-bottom: 20px !important;
  }
}
.about-section .section-paragraph {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  color: #000;
  margin-bottom: 60px;
}
@media (max-width: 1023px) {
  .about-section .section-paragraph {
    margin-bottom: 40px;
  }
}
.about-section .accordion-slider-container {
  display: flex;
  gap: 15px;
  height: 450px;
  transform: translateZ(0);
}
.about-section .panel {
  flex: 1 1;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: flex 0.4s ease;
  cursor: pointer;
  transform: translateZ(0);
  backface-visibility: hidden;
}
.about-section .panel .panel-content {
  display: none;
}
.about-section .panel.active {
  flex: 3 1;
}
.about-section .panel.active .panel-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 20px;
  z-index: 2;
  color: #fff;
}
.about-section .panel.active .panel-content .content-wrapper {
  background-color: rgba(37, 65, 139, 0.4);
  padding: 20px;
  border-radius: 20px;
  max-width: 100%;
  opacity: 0;
  animation: contentFade 0.7s ease 0.1s forwards;
  backdrop-filter: blur(16px);
}
.about-section .panel.active .panel-content h3 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 10px;
}
.about-section .panel.active .panel-content .panel-text {
  display: block;
}
.about-section .panel.active .panel-content .panel-text p {
  font-size: 16px;
  line-height: 1.6;
  color: #fff;
}
.about-section .panel.active .panel-content .panel-text p:last-child {
  margin-bottom: 0;
}
.about-section .panel .panel-image {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.about-section .panel .panel-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  image-rendering: -webkit-optimize-contrast; /* Chrome için görsel iyileştirme */
  image-rendering: crisp-edges; /* Firefox için görsel iyileştirme */
  transform: translateZ(0); /* Hardware acceleration */
  backface-visibility: hidden; /* Keskinlik için */
  perspective: 1000; /* Keskinlik için */
  will-change: transform; /* Tarayıcıya optimizasyon ipucu verir */
}

@keyframes contentFade {
  0% {
    opacity: 0;
    transform: translateY(-15px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 768px) {
  .about-section .section-title {
    font-size: 36px;
    margin-bottom: 40px;
  }
  .about-section .accordion-slider-container {
    display: block;
    height: 450px;
  }
  .about-section .accordion-slider-container.swiper {
    width: 100%;
    height: 450px;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    position: relative;
    z-index: 1;
  }
  .about-section .accordion-slider-container .swiper-slide {
    width: 100%;
    height: 100%;
  }
  .about-section .accordion-slider-container .swiper-button-prev,
  .about-section .accordion-slider-container .swiper-button-next {
    color: #fff;
  }
  .about-section .accordion-slider-container .swiper-button-prev:after,
  .about-section .accordion-slider-container .swiper-button-next:after {
    font-size: 24px;
    font-weight: bold;
  }
  .about-section .accordion-slider-container .swiper-pagination {
    position: absolute;
    bottom: 10px;
    z-index: 10;
    width: 100%;
    text-align: center;
  }
  .about-section .accordion-slider-container .swiper-pagination .swiper-pagination-bullet {
    background: #fff;
    opacity: 0.6;
    width: 10px;
    height: 10px;
    display: inline-block;
    margin: 0 5px;
    border-radius: 50%;
  }
  .about-section .accordion-slider-container .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
    opacity: 1;
    background: #004481;
  }
  .about-section .panel {
    height: 100%;
    border-radius: 10px;
  }
  .about-section .panel.active {
    flex: none;
  }
  .about-section .panel .panel-content {
    display: flex !important;
    flex-direction: column;
    justify-content: flex-end;
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 20px;
    z-index: 2;
    color: #fff;
    bottom: 0;
  }
  .about-section .panel .panel-content .content-wrapper {
    background-color: rgba(37, 65, 139, 0.6);
    backdrop-filter: blur(16px);
    padding: 20px;
    border-radius: 20px;
    width: 100%;
  }
  .about-section .panel .panel-content h3 {
    font-size: 24px;
    margin-bottom: 10px;
    font-weight: 600;
    opacity: 1 !important;
  }
  .about-section .panel .panel-content .panel-text {
    display: block !important;
    opacity: 1 !important;
  }
  .about-section .panel .panel-content .panel-text p {
    font-size: 16px;
    line-height: 1.5;
  }
  .about-section .swiper-slide .panel {
    width: 100%;
    height: 100%;
    margin: 0;
  }
}
.about-pagination {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  z-index: 10;
}
.about-pagination .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  margin: 8px 0;
  background: #004481;
  opacity: 0.5;
  transition: all 0.3s ease;
}
.about-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  opacity: 1;
  transform: scale(1.2);
}`, "",{"version":3,"sources":["webpack://./src/components/about/About.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,gBAAA;AAEJ;AAAI;EAHJ;IAIQ,eAAA;EAGN;AACF;AADI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAGR;AADQ;EAPJ;IAQQ,0BAAA;IACA,8BAAA;EAIV;AACF;AADI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AAGR;AADQ;EAPJ;IAQQ,mBAAA;EAIV;AACF;AADI;EACI,aAAA;EACA,SAAA;EACA,aAAA;EACA,wBAAA;AAGR;AAAI;EACI,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,0BAAA;EACA,eAAA;EACA,wBAAA;EACA,2BAAA;AAER;AAAQ;EACI,aAAA;AAEZ;AACQ;EACI,SAAA;AACZ;AACY;EACI,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;AAChB;AACgB;EACI,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,8CAAA;EACA,2BAAA;AACpB;AAEgB;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAApB;AAGgB;EACI,cAAA;AADpB;AAGoB;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AADxB;AAIoB;EACI,gBAAA;AAFxB;AAQQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AANZ;AAQY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,0CAAA,EAAA,mCAAA;EACA,4BAAA,EAAA,oCAAA;EACA,wBAAA,EAAA,0BAAA;EACA,2BAAA,EAAA,mBAAA;EACA,iBAAA,EAAA,mBAAA;EACA,sBAAA,EAAA,wCAAA;AANhB;;AAYA;EACI;IACI,UAAA;IACA,4BAAA;EATN;EAWE;IACI,UAAA;IACA,wBAAA;EATN;AACF;AAaA;EAGQ;IACI,eAAA;IACA,mBAAA;EAbV;EAgBM;IACI,cAAA;IACA,aAAA;EAdV;EAgBU;IACI,WAAA;IACA,aAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,kBAAA;IACA,UAAA;EAdd;EAiBU;IACI,WAAA;IACA,YAAA;EAfd;EAkBU;;IAEI,WAAA;EAhBd;EAiBc;;IACI,eAAA;IACA,iBAAA;EAdlB;EAkBU;IACI,kBAAA;IACA,YAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;EAhBd;EAkBc;IACI,gBAAA;IACA,YAAA;IACA,WAAA;IACA,YAAA;IACA,qBAAA;IACA,aAAA;IACA,kBAAA;EAhBlB;EAkBkB;IACI,UAAA;IACA,mBAAA;EAhBtB;EAsBM;IACI,YAAA;IACA,mBAAA;EApBV;EAsBU;IACI,UAAA;EApBd;EAuBU;IACI,wBAAA;IACA,sBAAA;IACA,yBAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;EArBd;EAuBc;IACI,wCAAA;IACA,2BAAA;IACA,aAAA;IACA,mBAAA;IACA,WAAA;EArBlB;EAwBc;IACI,eAAA;IACA,mBAAA;IACA,gBAAA;IACA,qBAAA;EAtBlB;EAyBc;IACI,yBAAA;IACA,qBAAA;EAvBlB;EAyBkB;IACI,eAAA;IACA,gBAAA;EAvBtB;EA8BM;IACI,WAAA;IACA,YAAA;IACA,SAAA;EA5BV;AACF;AAgCA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AA9BJ;AAgCI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;AA9BR;AAgCQ;EACI,UAAA;EACA,qBAAA;AA9BZ","sourcesContent":[".about-section {\n    padding: 150px 0;\n\n    @media (max-width: 1023px) {\n        padding: 96px 0;\n    }\n    \n    .section-title {\n        text-align: center;\n        font-size: 52px;\n        font-weight: 700;\n        margin-bottom: 30px;\n        color: #072146;\n\n        @media (max-width: 1023px) {\n            font-size: 40px !important;\n            margin-bottom: 20px !important;\n        }\n    }\n\n    .section-paragraph {\n        text-align: center;\n        font-size: 18px;\n        font-weight: 500;\n        color: #000;\n        margin-bottom: 60px;\n\n        @media (max-width: 1023px) {\n            margin-bottom: 40px;\n        }\n    }\n    \n    .accordion-slider-container {\n        display: flex;\n        gap: 15px;\n        height: 450px;\n        transform: translateZ(0);\n    }\n    \n    .panel {\n        flex: 1;\n        position: relative;\n        border-radius: 10px;\n        overflow: hidden;\n        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n        transition: flex 0.4s ease;\n        cursor: pointer;\n        transform: translateZ(0);\n        backface-visibility: hidden;\n        \n        .panel-content {\n            display: none;\n        }\n        \n        &.active {\n            flex: 3;\n            \n            .panel-content {\n                display: flex;\n                flex-direction: column;\n                justify-content: flex-end;\n                position: absolute;\n                width: 100%;\n                height: 100%;\n                padding: 20px;\n                z-index: 2;\n                color: #fff;\n                \n                .content-wrapper {\n                    background-color: rgba(37, 65, 139, 0.4);\n                    padding: 20px;\n                    border-radius: 20px;\n                    max-width: 100%;\n                    opacity: 0;\n                    animation: contentFade 0.7s ease 0.1s forwards;\n                    backdrop-filter: blur(16px);\n                }\n                \n                h3 {\n                    font-size: 22px;\n                    font-weight: 700;\n                    margin-bottom: 10px;\n                }\n                \n                .panel-text {\n                    display: block;\n                    \n                    p {\n                        font-size: 16px;\n                        line-height: 1.6;\n                        color: #fff;\n                    }\n                    \n                    p:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n        \n        .panel-image {\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            z-index: 1;\n            \n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n                image-rendering: -webkit-optimize-contrast; /* Chrome için görsel iyileştirme */\n                image-rendering: crisp-edges; /* Firefox için görsel iyileştirme */\n                transform: translateZ(0); /* Hardware acceleration */\n                backface-visibility: hidden; /* Keskinlik için */\n                perspective: 1000; /* Keskinlik için */\n                will-change: transform; /* Tarayıcıya optimizasyon ipucu verir */\n            }\n        }\n    }\n}\n\n@keyframes contentFade {\n    0% {\n        opacity: 0;\n        transform: translateY(-15px);\n    }\n    100% {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n// Mobil için Swiper özelleştirmeleri\n@media (max-width: 768px) {\n    .about-section {\n        \n        .section-title {\n            font-size: 36px;\n            margin-bottom: 40px;\n        }\n        \n        .accordion-slider-container {\n            display: block;\n            height: 450px;\n            \n            &.swiper {\n                width: 100%;\n                height: 450px;\n                margin-left: auto;\n                margin-right: auto;\n                overflow: hidden;\n                position: relative;\n                z-index: 1;\n            }\n            \n            .swiper-slide {\n                width: 100%;\n                height: 100%;\n            }\n            \n            .swiper-button-prev,\n            .swiper-button-next {\n                color: #fff;\n                &:after {\n                    font-size: 24px;\n                    font-weight: bold;\n                }\n            }\n            \n            .swiper-pagination {\n                position: absolute;\n                bottom: 10px;\n                z-index: 10;\n                width: 100%;\n                text-align: center;\n                \n                .swiper-pagination-bullet {\n                    background: #fff;\n                    opacity: 0.6;\n                    width: 10px;\n                    height: 10px;\n                    display: inline-block;\n                    margin: 0 5px;\n                    border-radius: 50%;\n                    \n                    &.swiper-pagination-bullet-active {\n                        opacity: 1;\n                        background: #004481;\n                    }\n                }\n            }\n        }\n        \n        .panel {\n            height: 100%;\n            border-radius: 10px;\n            \n            &.active {\n                flex: none;\n            }\n            \n            .panel-content {\n                display: flex !important;\n                flex-direction: column;\n                justify-content: flex-end;\n                position: absolute;\n                width: 100%;\n                height: 100%;\n                padding: 20px;\n                z-index: 2;\n                color: #fff;\n                bottom: 0;\n                \n                .content-wrapper {\n                    background-color: rgba(37, 65, 139, 0.6);\n                    backdrop-filter: blur(16px);\n                    padding: 20px;\n                    border-radius: 20px;\n                    width: 100%;\n                }\n                \n                h3 {\n                    font-size: 24px;\n                    margin-bottom: 10px;\n                    font-weight: 600;\n                    opacity: 1 !important;\n                }\n                \n                .panel-text {\n                    display: block !important;\n                    opacity: 1 !important;\n                    \n                    p {\n                        font-size: 16px;\n                        line-height: 1.5;\n                    }\n                }\n            }\n        }\n        \n        // Swiper içindeki panellerin özel stilleri\n        .swiper-slide .panel {\n            width: 100%;\n            height: 100%;\n            margin: 0;\n        }\n    }\n}\n\n.about-pagination {\n    position: absolute;\n    left: 20px;\n    top: 50%;\n    transform: translateY(-50%);\n    display: flex;\n    flex-direction: column;\n    z-index: 10;\n    \n    .swiper-pagination-bullet {\n        width: 10px;\n        height: 10px;\n        margin: 8px 0;\n        background: #004481;\n        opacity: 0.5;\n        transition: all 0.3s ease;\n        \n        &.swiper-pagination-bullet-active {\n            opacity: 1;\n            transform: scale(1.2);\n        }\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
